import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img-web/menu.png';
const _withScopeId = n => (_pushScopeId("data-v-486ae436"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "pad-menu"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_3 = [_hoisted_2];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_WebMenu = _resolveComponent("WebMenu");
  const _component_el_aside = _resolveComponent("el-aside");
  const _component_el_drawer = _resolveComponent("el-drawer");
  const _component_v_md_preview = _resolveComponent("v-md-preview");
  const _component_el_main = _resolveComponent("el-main");
  const _component_el_container = _resolveComponent("el-container");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
    class: "menu-container",
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.controlMenuVisible && _ctx.controlMenuVisible(...args))
  }, _hoisted_3)]), _createVNode(_component_el_container, {
    class: "web-section"
  }, {
    default: _withCtx(() => [!_ctx.isPadSize ? (_openBlock(), _createBlock(_component_el_aside, {
      key: 0,
      class: "web-layout-aside",
      width: "initial"
    }, {
      default: _withCtx(() => [_ctx.menuList.length > 0 ? (_openBlock(), _createBlock(_component_WebMenu, {
        key: 0,
        onShowMdFile: _ctx.showMdFile,
        menuList: _ctx.menuList
      }, null, 8, ["onShowMdFile", "menuList"])) : _createCommentVNode("", true)]),
      _: 1
    })) : _createCommentVNode("", true), _createVNode(_component_el_drawer, {
      modelValue: _ctx.isShowMenu,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.isShowMenu = $event),
      onClosed: _ctx.closedDrawer,
      direction: 'ltr',
      "with-header": false
    }, {
      default: _withCtx(() => [_ctx.menuList.length > 0 ? (_openBlock(), _createBlock(_component_WebMenu, {
        key: 0,
        onShowMdFile: _ctx.showMdFile,
        menuList: _ctx.menuList
      }, null, 8, ["onShowMdFile", "menuList"])) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["modelValue", "onClosed"]), _createVNode(_component_el_main, null, {
      default: _withCtx(() => [_createVNode(_component_v_md_preview, {
        class: "doc-main",
        text: _ctx.markdown
      }, null, 8, ["text"])]),
      _: 1
    })]),
    _: 1
  })], 64);
}